import { ROUTES } from '@/shared/config'
import { navigateToFx } from '@/shared/lib/providers'
import {
  $lastCreatedAlbumId,
  AlbumFormTabsKeys,
  lastCreatedAlbumIdReset,
} from '@/widgets/AlbumForm'
import { $albumCommonInformationFormInitialAuthor } from '@/widgets/AlbumForm'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'
import { type NavigateOptions } from 'react-router-dom'

export const AlbumCreatePageGate = createGate()
const navigateToEditAlbumFx = createEvent<string>()
sample({
  clock: [$lastCreatedAlbumId, AlbumCreatePageGate.open],
  source: $lastCreatedAlbumId,
  filter: (id): id is string => typeof id === 'string',
  target: navigateToEditAlbumFx,
})
sample({
  source: $albumCommonInformationFormInitialAuthor,
  clock: navigateToEditAlbumFx,
  fn: (author, id) => ({
    to: ROUTES.COLLECTIONS.EDIT_ALBUM.replace(':id', id),
    options: {
      state: {
        activeTab: AlbumFormTabsKeys.Tracks,
        author,
      },
    } as NavigateOptions,
  }),
  target: [navigateToFx, lastCreatedAlbumIdReset],
})
